import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EMAIL = "operations@anantora.com";

const Contact = () => {
  const [emailHovered, setEmailHovered] = useState(false);

  return (
    <section
      data-testid="contact-section"
      id="contact"
      style={{
        padding: "clamp(80px, 12vw, 160px) clamp(24px, 6vw, 96px) 0",
        borderTop: "1px solid #1A1A1A",
      }}
    >
      {/* Section number */}
      <span
        style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "11px",
          color: "#FF3B00",
          letterSpacing: "0.22em",
          display: "block",
          marginBottom: "14px",
        }}
      >
        [04]
      </span>

      {/* Heading */}
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true }}
        style={{
          fontFamily: "'Cabinet Grotesk', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(2.5rem, 5.5vw, 6rem)",
          lineHeight: 0.95,
          letterSpacing: "-0.04em",
          color: "#F4F4F0",
          textTransform: "uppercase",
          margin: "0 0 clamp(40px, 6vw, 80px) 0",
        }}
      >
        Let's Build<br />Something<br />Enduring.
      </motion.h2>

      {/* Email CTA */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.25, duration: 0.9 }}
        viewport={{ once: true }}
        style={{ marginBottom: "clamp(80px, 10vw, 140px)" }}
      >
        <p
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "11px",
            color: "#444444",
            letterSpacing: "0.2em",
            marginBottom: "16px",
          }}
        >
          REACH US AT
        </p>

        <a
          data-testid="contact-email"
          href={`mailto:${EMAIL}`}
          onMouseEnter={() => setEmailHovered(true)}
          onMouseLeave={() => setEmailHovered(false)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            fontFamily: "'Cabinet Grotesk', sans-serif",
            fontWeight: 600,
            fontSize: "clamp(1.2rem, 3.2vw, 3.2rem)",
            color: emailHovered ? "#FF3B00" : "#888888",
            textDecoration: "none",
            letterSpacing: "-0.02em",
            borderBottom: `1px solid ${emailHovered ? "#FF3B00" : "#1A1A1A"}`,
            paddingBottom: "6px",
            transition: "color 0.35s ease, border-color 0.35s ease",
          }}
        >
          {EMAIL}
          <ArrowUpRight
            size={clampIconSize()}
            strokeWidth={1.5}
            style={{
              opacity: emailHovered ? 1 : 0.3,
              transform: emailHovered ? "translate(4px, -4px)" : "translate(0, 0)",
              transition: "opacity 0.35s ease, transform 0.35s ease",
              flexShrink: 0,
            }}
          />
        </a>
      </motion.div>

      {/* Footer */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
        viewport={{ once: true }}
        style={{
          borderTop: "1px solid #111111",
          padding: "28px 0 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "10px",
            color: "#2A2A2A",
            letterSpacing: "0.15em",
          }}
        >
          ANANTORA © 2025 — ALL RIGHTS RESERVED
        </span>
        <div style={{ display: "flex", gap: "32px", alignItems: "center" }}>
          <span
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "10px",
              color: "#2A2A2A",
              letterSpacing: "0.15em",
            }}
          >
            anantora.com
          </span>
          <div
            style={{
              width: "6px",
              height: "6px",
              backgroundColor: "#FF3B00",
              borderRadius: "50%",
            }}
          />
        </div>
      </motion.div>
    </section>
  );
};

// Utility: returns a fixed icon size (can't use clamp in JS)
function clampIconSize() {
  return 28;
}

export default Contact;
